import i18n from 'i18next';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {Col, Container, Row, Spinner} from 'react-bootstrap';
import {useCognitoLogin} from './useCognitoLogin';

const AuthRedirect = (props) => {
	useCognitoLogin();

	useEffect(() => {
		if (props?.isLoggedIn) {
			localStorage.removeItem('cognitoLoginInProgress');
			window.location.replace('/simplifyworks/dashboard');
		}
	}, [props?.isLoggedIn]);

	return (
		<Container fluid className="vh-100 d-flex justify-content-center align-items-center">
			<Row>
				<Col className="text-center">
					<Spinner animation="border" role="status" variant="primary"/>
					<p className="mt-3">Processing login...</p>
				</Col>
			</Row>
		</Container>
	);
};

const mapStateToProps = (state) => {
	return {
		isLoggedIn: state?.security?.status === 'loggedIn'
	};
};

export default {
	title: () => i18n.t('foedus-redirect'),
	main: connect(mapStateToProps)(AuthRedirect)
};
